import { useEffect, useRef } from "react";

const LINK = 150;

export const NeuralBackground = ({ dark = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current, ctx = c.getContext("2d");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let w, h, nodes = [], pulses = [], raf;
    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      w = c.offsetWidth; h = c.offsetHeight;
      c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.min(90, Math.round((w * h) / 14000));
      nodes = Array.from({ length: n }, () => ({ x: Math.random() * w, y: Math.random() * h, vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3, r: 1.5 + Math.random() * 2 }));
      pulses = [];
    };
    const frame = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of nodes) {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > w) p.vx *= -1;
        if (p.y < 0 || p.y > h) p.vy *= -1;
      }
      for (let i = 0; i < nodes.length; i++) for (let j = i + 1; j < nodes.length; j++) {
        const a = nodes[i], b = nodes[j], d = Math.hypot(a.x - b.x, a.y - b.y);
        if (d > LINK) continue;
        ctx.strokeStyle = dark ? `rgba(255,255,255,${0.14 * (1 - d / LINK)})` : `rgba(43,48,54,${0.22 * (1 - d / LINK)})`; ctx.lineWidth = 0.8;
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
        if (pulses.length < 18 && Math.random() < 0.0015) pulses.push({ a, b, t: 0, s: 0.008 + Math.random() * 0.012 });
      }
      pulses = pulses.filter((p) => Math.hypot(p.a.x - p.b.x, p.a.y - p.b.y) <= LINK && (p.t += p.s) <= 1);
      for (const p of pulses) {
        const x = p.a.x + (p.b.x - p.a.x) * p.t, y = p.a.y + (p.b.y - p.a.y) * p.t;
        const g = ctx.createRadialGradient(x, y, 0, x, y, 10);
        g.addColorStop(0, "rgba(224,38,44,0.95)"); g.addColorStop(1, "rgba(224,38,44,0)");
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, 10, 0, Math.PI * 2); ctx.fill();
      }
      for (const p of nodes) {
        ctx.fillStyle = dark ? "rgba(255,255,255,0.35)" : "rgba(43,48,54,0.55)"; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      }
      if (!reduce) raf = requestAnimationFrame(frame);
    };
    resize(); frame();
    window.addEventListener("resize", resize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, [dark]);
  return <canvas ref={ref} data-testid="neural-background" aria-hidden="true" className="absolute inset-0 w-full h-full pointer-events-none" />;
};
